// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const unpublishStyle = theme => ({
	title: {
		paddingBottom: theme.spacing(1)
	},

	paper: {
		marginBottom: theme.spacing(1)
	},

	messageArea: {
		width: "100%",
		paddingTop: theme.spacing(3),
		textAlign: 'center',
	}
})


export default unpublishStyle